document.addEventListener("DOMContentLoaded", function(){
  initHeroIngredientsMobile();
  selectDefaultBottleVariant();
  initVariantPriceSync();
  applyDemoJudgeMeReviews();
});

window.addEventListener("load", function(){

});

/**
 * Limits visible <li> items inside .hero-ingredients-list on mobile (<=749px)
 * and shows a dynamic "PLUS X MORE" toggle to reveal the rest.
 *
 * Drop this single function inside your existing DOMContentLoaded block,
 * then just call: initHeroIngredientsMobile();
 * It wires up its own resize listener internally, so nothing else is needed.
 */
function initHeroIngredientsMobile() {
  var BREAKPOINT = 749;
  var VISIBLE_COUNT = 16; // how many items to show before truncating on mobile

  function renderContainer(container) {
    var list = container.querySelector('ul');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'))
      .filter(function (li) {
        return !li.classList.contains('hero-ingredients-toggle');
      });

    if (items.length === 0) return;

    // Cache original items once so repeated calls (resize) don't lose data
    if (!container._heroIngredientsItems) {
      container._heroIngredientsItems = items;
    }
    items = container._heroIngredientsItems;

    var isMobile = window.innerWidth <= BREAKPOINT;

    // Remove any existing toggle item before re-rendering
    var existingToggle = list.querySelector('.hero-ingredients-toggle');
    if (existingToggle) existingToggle.remove();

    if (!isMobile) {
      items.forEach(function (li) {
        li.style.display = '';
      });
      return;
    }

    var expanded = container._heroIngredientsExpanded === true;

    if (expanded) {
      items.forEach(function (li) {
        li.style.display = '';
      });
      return;
    }

    items.forEach(function (li, index) {
      li.style.display = index < VISIBLE_COUNT ? '' : 'none';
    });

    var remaining = items.length - VISIBLE_COUNT;
    if (remaining > 0) {
      var toggle = document.createElement('li');
      toggle.className = 'hero-ingredients-toggle';
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.textContent = 'PLUS ' + remaining + ' MORE';

      toggle.addEventListener('click', function () {
        container._heroIngredientsExpanded = true;
        renderContainer(container);
      });
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        }
      });

      list.appendChild(toggle);
    }
  }

  function renderAll() {
    var containers = document.querySelectorAll('.hero-ingredients-list');
    containers.forEach(function (container) {
      renderContainer(container);
    });
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  renderAll();
  window.addEventListener('resize', debounce(renderAll, 150));
}

function selectDefaultBottleVariant() {
  var hasVariantParam = new URL(window.location.href).searchParams.has('variant');
  if (hasVariantParam) return false;

  var variantFieldset = document.querySelector('variant-picker fieldset[data-option="choose-options"]');
  if (!variantFieldset) return false;

  function findDefaultTarget() {
    return Array.from(variantFieldset.querySelectorAll('input[type="radio"]')).find(function (input) {
      var label = input.getAttribute('aria-label') || '';
      return label.indexOf('2 Bottles') === 0;
    });
  }

  var target = findDefaultTarget();
  if (!target) return false;

  if (!target.checked) {
    // Fires a bubbling 'change' event, which the theme's <variant-picker>
    // listens for to update the price, variant ID and Add to Cart form.
    target.click();
  }
  // If it's already checked, the page was rendered with this variant,
  // so everything is already in sync and nothing else is needed.

  return true;
}

function initVariantPriceSync() {
  document.addEventListener('az:variant-selected', (event) => {
    var variantPickers = document.querySelectorAll(".product-details variant-picker");
    const selectedVariantId = parseInt(event?.detail?.variantId);
    if (!variantPickers || !selectedVariantId) return;

    variantPickers.forEach(picker => {
      const selectedVariant = picker.querySelector(`input[data-variant-id="${selectedVariantId}"]`) || null;
      if(!selectedVariant) return;

      const priceBlock = picker.closest(".product-details")?.querySelector("product-price") || null;
      if(!priceBlock) return;

      const salePriceEl = priceBlock.querySelector(".price-item__group.price")?.childNodes[2]
      const comparePriceEl = priceBlock.querySelector(".price-item__group.compare-at-price")?.childNodes[2];
      const savedAmountEl = priceBlock.querySelector(".saved-amount strong");

      if(!salePriceEl) return;
      salePriceEl.textContent = selectedVariant.getAttribute("data-sale-price");

      if(!comparePriceEl) return;
      comparePriceEl.textContent = selectedVariant.getAttribute("data-compare-price");
      savedAmountEl.textContent = selectedVariant.getAttribute("data-saving-price");

    });
  });
}

function applyDemoJudgeMeReviews({ rating = 4.9, total = 341, counts = { 5: 316, 4: 20, 3: 4, 2: 0, 1: 1 }} = {}) {
  const ratingText = rating.toFixed(1);
  const sidebar = '.jm-review-widget-sidebar-header__sidebar';

  const setText = (el, text) => {
    if (el && el.textContent.trim() !== String(text)) el.textContent = text;
  };
  const setAttr = (el, name, value) => {
    if (el && el.getAttribute(name) !== String(value)) el.setAttribute(name, value);
  };
  // Reveals the element (the CSS hides anything without data-az)
  const reveal = (el) => {
    if (el && !el.hasAttribute('data-az')) el.setAttribute('data-az', '');
  };

  function apply() {
    // 1. Preview badges
    document.querySelectorAll('.jdgm-prev-badge__text').forEach((el) => {
      setText(el, `${ratingText} (${total})`);
      reveal(el);
    });
    document.querySelectorAll('.jdgm-prev-badge').forEach((el) => {
      setAttr(el, 'data-average-rating', ratingText);
      setAttr(el, 'data-number-of-reviews', total);
    });

    // 2. Sidebar average rating + review count
    document
      .querySelectorAll(`${sidebar} > .jm-stack .jm-average-rating-display > div > p:first-child`)
      .forEach((el) => {
        setText(el, ratingText);
        reveal(el);
      });

    document
      .querySelectorAll(`${sidebar} > .jm-stack .jm-average-rating-display > div > p:last-child`)
      .forEach((el) => {
        setText(el, `${total} reviews`);
        reveal(el);
      });

    // 3. Histogram
    document.querySelectorAll(`${sidebar} > .jm-histogram`).forEach((histogram) => {
      let updatedRows = 0;

      histogram.querySelectorAll('.jm-histogram-row').forEach((row) => {
        const star = parseInt(row.querySelector('.jm-histogram-row__rating')?.textContent, 10);
        if (!(star in counts)) return;

        const count = counts[star];
        const exactPct = (count / total) * 100;
        const roundedPct = Math.round(exactPct);

        setText(row.querySelector('.jm-histogram-row__frequency'), count);

        const fill = row.querySelector('.jm-progress-bar__fill');
        if (fill && fill.style.width !== `${exactPct.toFixed(1)}%`) {
          fill.style.width = `${exactPct.toFixed(1)}%`;
        }

        setAttr(row, 'aria-label', `${roundedPct}% (${count}) reviews with ${star} star rating`);
        updatedRows++;
      });

      // Only reveal once the rows actually exist and were updated
      if (updatedRows) reveal(histogram);
    });
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'aria-label'],
  });

  apply();

  return () => observer.disconnect();
}